import { afterRequestHook, beforeRequestHook } from '@/api/config'
import { getAccessToken, refreshAuthLogic } from '@/auth'
import { defineHttp } from '@tellus/http'
import { createAuthRefreshHandler } from '@tellus/http-auth-refresh'
import { afterRequestCatchHook } from './requestHandler'

/**
 * Http instance
 */
export const useHttp = defineHttp({
  id: '__DEFAULT_HTTP__',
  // eslint-disable-next-line no-process-env
  prefixUrl: process.env.VUE_APP_BASE_API,
  timeout: 500000,
  hooks: {
    afterRequestHook,
    beforeRequestHook,
    afterRequestCatchHook
  },
  authConfig: {
    type: 'jwt',
    tokenGetter: getAccessToken
  }
})

createAuthRefreshHandler(useHttp, refreshAuthLogic, {
  pauseInstanceWhileRefreshing: true
})
